import { FC } from "react"
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"


interface Type {
  isShow: boolean
  title?: string
  content?: string
  cancelText?: string
  confirmText?: string
  cancelAction?: () => void
  confirmAction?: () => void
}

/**
 * general dialog component for clinical module
 * @param param0 
 * @returns 
 */
const GeneralClinicalDialog: FC<Type> = ({
  isShow = false,
  title,
  content,
  cancelText,
  confirmText,
  cancelAction,
  confirmAction,
}) => (
  <Dialog open={isShow}>
    <Box sx={{ width: 444 }}>
      {title&&<DialogTitle>
        {title||"Message Title"}
      </DialogTitle>}
      {content&&<DialogContent>
        <DialogContentText>
          {content||"Message Content"}
        </DialogContentText>
      </DialogContent>}
      <DialogActions>
        {
        cancelAction&&<Button
          onClick={() => {
            cancelAction();
          }}
        >
          {cancelText||"CANCEL"}
        </Button>
        }
        {
        confirmAction&&<Button
          variant="contained"
          onClick={() => {
            confirmAction()
          }}
          autoFocus
        >
          {confirmText||"OK"}
        </Button>
        }
      </DialogActions>
    </Box>
  </Dialog>
)

export default GeneralClinicalDialog
